import clsx from 'clsx';

import classes from './analyticsDetail.module.css';

export type TileSize = 'normal' | 'large';

export const tileSizeClass: Record<TileSize, string> = {
  normal: classes.normal,
  large: classes.large,
};

interface Props {
  url: any;
  tileSize: TileSize;
}

const AnalyticsTile = ({ url, tileSize }: Props) => {
  return (
    <div
      className={clsx(classes.analyticsTileContainer, tileSizeClass[tileSize])}
    >
      <iframe
        width="100%"
        height="100%"
        src={url}
        frameBorder="0"
        style={{ border: 0, overflow: 'hidden' }}
        allowFullScreen
      />
    </div>
  );
};

export default AnalyticsTile;
